import { useContext, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { AuthContext } from "../context/authContext";
import { useSearchParams } from "react-router-dom";
import { useTranslation } from "react-i18next";

export default function ConfirmUser() {
  const authContext = useContext(AuthContext);
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const { i18n } = useTranslation();
  const changeLanguage = (lng) => {
    i18n.changeLanguage(lng);
  };

  useEffect(() => {
    const username = searchParams.get("user_name");
    const confirmationCode = searchParams.get("confirmation_code");
    const country = searchParams.get("country");
    const storageCountry = localStorage.getItem("countryCode");
    if (storageCountry == null || storageCountry == "null") {
      localStorage.setItem("countryCode", country);
    }
    if (country?.toUpperCase() == "DE") {
      changeLanguage("de");
    }
    try {
      authContext.verifyCode(username, confirmationCode);
      navigate("/", {
        state: {
          type: "confirmUser",
          message: "confirmUser.message",
        },
      });
    } catch (error) {
      alert(error);
    }
    // eslint-disable-next-line
  }, []);

  return (
    <>
      <div className="content-page"></div>
    </>
  );
}
